export default {
    apiPath: 'http://postcard.dev/api/',
    basePath: 'http://postcard.dev/',
    basename: '/'
};


// WEBPACK FOOTER //
// ./src/config/dev.js